// src/pages/TermsAndConditions.jsx
import React from "react";
import PolicyLayout from "../components/common/PolicyLayout";
import "../components/common/styles/policyPages.css";

const TermsAndConditions = () => {
  return (
    <PolicyLayout
      title="MSZILA Terms and Conditions of Use"
      subtitle="PLEASE READ THE FOLLOWING TERMS AND CONDITIONS CAREFULLY BEFORE USING MSZILA SERVICES"
    >
      <div className="policy-card">

        {/* =====================================================
            PART A – TERMS APPLICABLE TO ALL USERS
        ===================================================== */}

        <section>
          <h2 className="policy-main-title">A. Terms Applicable to All Users</h2>

          <p className="policy-section-text">
            The following agreement captures the terms and conditions of use
            (&quot;Agreement&quot;), applicable to your use of MSZILA
            (&quot;Web Site&quot; &amp; &quot;Mobile App&quot;), which provides
            a digital platform for marketing, advertisement, selling,
            purchasing, or providing services.
          </p>

          <p className="policy-section-text">
            This Agreement is entered into between you as a User of MSZILA
            and ICAME SOFTWARE SOLUTIONS PRIVATE LIMITED (&quot;ICAME&quot;).
          </p>

          <p className="policy-section-text">
            By accessing or using MSZILA services, you confirm that you have
            read, understood, and accepted this Agreement. If you do not
            agree, you must not use MSZILA services.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">
            I. Website & Mobile App – Merely a Venue / Platform
          </h3>
          <p className="policy-section-text">
            MSZILA acts solely as a digital platform enabling Users to
            interact and transact. ICAME/MSZILA is not a party to any
            transaction or agreement between Users.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">II. User Eligibility</h3>
          <p className="policy-section-text">
            MSZILA services may only be used by individuals who are at least
            18 years of age and legally capable of entering into binding
            agreements.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">
            III. Intellectual Property Rights
          </h3>
          <p className="policy-section-text">
            All content on the Web Site/Mobile App is owned or licensed by
            ICAME/MSZILA and protected by applicable intellectual property
            laws.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">
            IV. Limitation of Liability
          </h3>
          <p className="policy-section-text">
            Services are provided on an “as is” basis. ICAME/MSZILA shall not
            be liable for indirect, incidental, or consequential damages.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">
            V. Governing Law & Jurisdiction
          </h3>
          <p className="policy-section-text">
            These terms shall be governed by the laws of India and subject
            to the exclusive jurisdiction of courts at Mainpuri,
            Uttar Pradesh.
          </p>
        </section>

        {/* =====================================================
            PART B – ADDITIONAL TERMS FOR MERCHANTS / SERVICE PROVIDERS
        ===================================================== */}

        <section id="merchant-terms">
          <h2 className="policy-main-title">
            B. Additional Terms for Merchants / Service Providers
          </h2>

          <p className="policy-section-text">
            These additional terms apply specifically to Merchants and
            Service Providers using MSZILA for business promotion,
            advertisement, or service offerings.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">
            VI. Services Provided to Merchants / Service Providers
          </h3>

          <ul>
            <li><strong>Leading Manufacturer / Wholesaler / Distributor / Retailer</strong> – Priority category listing</li>
            <li><strong>Leading Service Provider</strong> – Enhanced visibility</li>
            <li><strong>Sponsored</strong> – Paid promotion for leads</li>
            <li><strong>Verified</strong> – Business verification badge</li>
            <li><strong>TrustSEAL</strong> – Document verification seal</li>
            <li><strong>Professional / Promotional / Customized Digital Cards</strong></li>
            <li><strong>Mini Dynamic Catalog</strong></li>
            <li><strong>Printed Collective Advertisement</strong> – Eco-friendly district-wise advertising</li>
          </ul>
        </section>

        <section>
          <h3 className="policy-section-title">
            VII. Merchant / Service Provider Eligibility & Responsibility
          </h3>

          <p className="policy-section-text">
            Merchants must be legally authorized individuals or business
            entities. Merchants are solely responsible for content accuracy,
            legality, compliance, and due diligence.
          </p>

          <p className="policy-section-text">
            ICAME/MSZILA reserves the right to suspend or terminate merchant
            accounts at its sole discretion.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">
            VIII. CRM Services
          </h3>
          <p className="policy-section-text">
            CRM services are cloud-based tools provided for business use.
            Merchants retain full responsibility for data, content, and
            compliance.
          </p>
        </section>

        <section>
          <h3 className="policy-section-title">
            IX. Indemnification
          </h3>
          <p className="policy-section-text">
            Merchants agree to indemnify and hold harmless ICAME/MSZILA from
            any claims arising from misuse of services, illegal activity,
            or breach of these terms.
          </p>
        </section>

        <div className="policy-meta">
          Last updated: 24/11/2025
        </div>

      </div>
    </PolicyLayout>
  );
};

export default TermsAndConditions;
